import { Box, Tabs, Tab, Button, CircularProgress, Alert, FormControlLabel, Checkbox } from "@mui/material";


import Dropzone from "react-dropzone";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";



import ReactCrop from "react-image-crop";


import { NumberInput } from "../index.js";

/** Presentational section; state and actions remain owned by its parent. */
export default function ImageUploadForm({ fileError, setFileError, value, handleChange, a11yProps, TabPanel, setfilename, setPreview, setFileNames, setOnDrag, ondrag, src, loading, handleUploadImage2, setOpen, croping, filename, crop, setCrop, setCompletedCrop, imgRef, onLoad, previewCanvasRef, setCroping, resizing, setResizing, setQuality, quality, setHeight, height, handleUploadImage }) {
  return (
<div>
      {fileError && <Alert severity="error">{fileError}</Alert>}
      {" "}
      <Box
        sx={{ borderBottom: 1, borderColor: "divider" }}
        className="relative z-10"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="  آپلود عادی" {...a11yProps(0)} />
          <Tab label="  آپلود  با امکانات" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        {" "}
        <div className="flex w-full justify-center mt-2">
          <Dropzone
            accept={{ "image/*": [] }} multiple={false}
            onDropRejected={() => setFileError("فقط فایل تصویر معتبر انتخاب کنید.")}
            onDrop={(acceptedFiles) => {
              if (!acceptedFiles.length) return;
              setFileError("");
              setfilename(acceptedFiles[0]);
              setPreview(acceptedFiles[0]);
              setFileNames(acceptedFiles[0].name?.split(".")[0]);
            }}
            onDragEnter={() => setOnDrag(true)}
            onDragLeave={() => setOnDrag(false)}
          >
            {({ getRootProps, getInputProps }) => (
              <section>
                <Box
                  {...getRootProps()}
                  style={{
                    width: "165px",
                    height: "165px",
                    backgroundColor: "#fff",
                    border: ondrag ? "" : "1px solid #ccc",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "36px",
                    flexDirection: "column",
                  }}
                  className={ondrag ? "enterDrag" : ""}
                >
                  <input {...getInputProps()} />
                  <AddAPhotoOutlinedIcon
                    className=" text-gray-500"
                    fontSize="inherit"
                  />
                  <span className="text-xs text-center text-gray-500 mt-3">
                    فایل بکشید و رها کنید یا کلیک کنید
                  </span>
                </Box>
              </section>
            )}
          </Dropzone>
        </div>    <div className="flex items-center justify-center my-3">
                  {src && <img src={src} alt="" width={200} height={200} />}
                </div>
        <div className="flex justify-center mt-5 gap-6">
          <Button
            sx={{ width: "140px" }}
            type="button" disabled={loading || !filename}
            onClick={handleUploadImage2}
            variant="contained"
          >
            {loading ? <CircularProgress /> : <> ثبت اطلاعات</>}
          </Button>
          <Button
            sx={{ width: "140px" }}
            disabled={loading}
            variant="contained"
            color="error"
            onClick={() => setOpen(false)}
          >
            انصراف
          </Button>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {" "}
        <Alert variant="outlined" severity="info">
          تمامی عکس ها جز تایپ svg و gif به webp تبدیل میشوند
        </Alert>
        <div className="croper-wrpaer">
          <div>
            <>
              <div className="flex w-full justify-center">
                <Dropzone
                  accept={{ "image/*": [] }} multiple={false}
                  onDropRejected={() => setFileError("فقط فایل تصویر معتبر انتخاب کنید.")}
                  onDrop={(acceptedFiles) => {
                    if (!acceptedFiles.length) return;
                    setFileError("");
                    setfilename(acceptedFiles[0]);
                    setPreview(acceptedFiles[0]);
                    setFileNames(acceptedFiles[0].name?.split(".")[0]);
                  }}
                  onDragEnter={() => setOnDrag(true)}
                  onDragLeave={() => setOnDrag(false)}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <Box
                        {...getRootProps()}
                        style={{
                          width: "165px",
                          height: "165px",
                          backgroundColor: "#fff",
                          border: ondrag ? "" : "1px solid #ccc",
                          borderRadius: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "36px",
                          flexDirection: "column",
                        }}
                        className={ondrag ? "enterDrag" : ""}
                      >
                        <input {...getInputProps()} />
                        <AddAPhotoOutlinedIcon
                          className=" text-gray-500"
                          fontSize="inherit"
                        />
                        <span className="text-xs text-center text-gray-500 mt-3">
                          فایل بکشید و رها کنید یا کلیک کنید
                        </span>
                      </Box>
                    </section>
                  )}
                </Dropzone>
              </div>

              {croping ? (
                <>
                  {" "}
                  {src && (
                    <>
                      {" "}
                      <div className="img-croper-body my-5">
                        {filename && (
                          <ReactCrop
                            style={{ maxHeight: "100%" }}
                            crop={crop}
                            onChange={(crop, percentCrop) =>
                              setCrop(percentCrop)
                            }
                            onComplete={(c) => setCompletedCrop(c)}
                          >
                            {" "}
                            <img
                              ref={imgRef}
                              alt="Crop me"
                              src={src}
                              /*    style={{
                      transform: `scale(${scale}) rotate(${rotate}deg)`,
                    }} */
                              onLoad={onLoad}
                            />
                          </ReactCrop>
                        )}
                      </div>
                      <canvas
                        style={{ width: 0, height: 0, display: "none" }}
                        ref={previewCanvasRef}
                        width="0"
                        height="0"
                      />
                    </>
                  )}
                </>
              ) : (
                <div className="flex items-center justify-center my-3">
                  {src && <img src={src} alt="" width={200} height={200} />}
                </div>
              )}
              <div className="flex justify-center mt-5 gap-6">
                <FormControlLabel
                  control={<Checkbox checked={croping} />}
                  onChange={() => {
                    setCroping(!croping);
                  }}
                  label={<h2 className=" text-[0.78rem]"> استفاده از کراپر</h2>}
                />
                <FormControlLabel
                  control={<Checkbox checked={resizing} />}
                  onChange={() => {
                    setResizing(!resizing);
                  }}
                  label={<h2 className=" text-[0.78rem]"> کم کردن حجم عکس </h2>}
                />
              </div>
              {resizing ? (
                <div className="grid md:grid-cols-2 gap-7 mt-7">
                  {" "}
                  <NumberInput
                    label=" درصد کیفیت عکس"
                    change={setQuality}
                    value={quality}
                  />{" "}
                  <NumberInput
                    label="  حداکثر ارتفاع"
                    change={setHeight}
                    value={height}
                  />
                </div>
              ) : (
                <></>
              )}
              <div className="flex justify-center mt-5 gap-6">
                <Button
                  sx={{ width: "140px" }}
                  type="button" disabled={loading || !filename}
                  onClick={handleUploadImage}
                  variant="contained"
                >
                  {loading ? <CircularProgress /> : <> ثبت اطلاعات</>}
                </Button>
                <Button
                  sx={{ width: "140px" }}
                  disabled={loading}
                  variant="contained"
                  color="error"
                  onClick={() => setOpen(false)}
                >
                  انصراف
                </Button>
              </div>
            </>
          </div>
        </div>
      </TabPanel>
    </div>
  );
}
